import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const fieldWrapperInvalidCss = "ff2y27r";
const fieldWrapperIsPhoneCss = "fb6nh5y";
const fieldWrapperCss = "f19a1qc3";
export const FieldWrapper = forwardRef((props, ref) => {
  const {
    invalid,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(fieldWrapperCss, {
    [fieldWrapperInvalidCss]: invalid,
    [fieldWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const fieldLabelIsPhoneCss = "f1htktsu";
const fieldLabelCss = "fqaoe3w";
export const FieldLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(fieldLabelCss, {
    [fieldLabelIsPhoneCss]: isPhone
  }, props.className)} />;
});
const fieldInputIsPhoneCss = "f1pn5kr3";
const fieldInputCss = "fvm3lm8";
export const FieldInput = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(fieldInputCss, {
    [fieldInputIsPhoneCss]: isPhone
  }, props.className)} />;
});

require("./field_parts.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./field_parts.js");